var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoffeeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 998.56 998.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #efdaca;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke: #333;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 48px;\n      }\n\n      .cls-7 {\n        fill: #333;\n        filter: url(#drop-shadow-9);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #d6d6d6;\n      }\n\n      .cls-4 {\n        fill: #ffc557;\n      }\n\n      .cls-5 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        fill: #80adac;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-9",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 21
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 499.28,
    cy: 499.28,
    r: 475.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M499.28,974.56c262.49,0,475.28-212.79,475.28-475.28H24c0,262.49,212.79,475.28,475.28,475.28Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "658.37 836.2 340.19 836.2 304.64 292.29 693.93 292.29 658.37 836.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 263.99,
    y: 218.81,
    width: 470.58,
    height: 73.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 313.82,
    y: 162.37,
    width: 370.92,
    height: 56.45
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "315.63 460.52 682.93 460.52 672.41 621.48 326.16 621.48 315.63 460.52"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 499.28,
    cy: 499.28,
    r: 475.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M499.28,974.56c262.49,0,475.28-212.79,475.28-475.28H24c0,262.49,212.79,475.28,475.28,475.28Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "658.37 836.2 340.19 836.2 304.64 292.29 693.93 292.29 658.37 836.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 263.99,
    y: 218.81,
    width: 470.58,
    height: 73.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 313.82,
    y: 162.37,
    width: 370.92,
    height: 56.45
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "315.63 460.52 682.93 460.52 672.41 621.48 326.16 621.48 315.63 460.52"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 499.28,
    cy: 499.28,
    r: 475.28
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M318.17,499.28H24c0,262.49,212.79,475.28,475.28,475.28s475.28-212.79,475.28-475.28"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "658.37 836.2 340.19 836.2 304.64 292.29 693.93 292.29 658.37 836.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 263.99,
    y: 218.81,
    width: 470.58,
    height: 73.48
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 313.82,
    y: 162.37,
    width: 370.92,
    height: 56.45
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "315.63 460.52 682.93 460.52 672.41 621.48 326.16 621.48 315.63 460.52"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M959.32,304.93c-25.15-59.46-61.14-112.85-106.99-158.7-45.85-45.85-99.24-81.84-158.7-106.99C632.06,13.2,566.67,0,499.28,0s-132.78,13.2-194.35,39.25c-59.46,25.15-112.85,61.14-158.7,106.99-45.85,45.85-81.84,99.24-106.99,158.7C13.2,366.5,0,431.89,0,499.28c0,10.53.32,21.01.97,31.44.26,4.17.57,8.33.93,12.48.54,6.23,1.2,12.43,1.97,18.62.29,2.36.61,4.71.94,7.06.78,5.57,1.65,11.13,2.61,16.66.84,4.8,1.74,9.59,2.72,14.36.59,2.9,1.21,5.79,1.86,8.67.38,1.68.76,3.36,1.15,5.04,2.69,11.47,5.79,22.84,9.3,34.11.81,2.6,1.65,5.2,2.5,7.79,1.88,5.7,3.86,11.37,5.96,17.01.83,2.24,1.68,4.48,2.54,6.72,1.27,3.29,2.58,6.58,3.93,9.85.62,1.51,1.24,3.02,1.88,4.52.98,2.32,1.98,4.62,3,6.92,10.15,23.02,21.94,45.11,35.32,66.18.47.75.95,1.49,1.42,2.23,10.61,16.51,22.19,32.39,34.73,47.58,10.21,12.38,21.06,24.31,32.52,35.78,45.85,45.85,99.24,81.84,158.7,106.99,28.86,12.21,58.56,21.59,88.91,28.12,4.05.87,8.11,1.69,12.17,2.46,4.07.77,8.15,1.49,12.24,2.15,26.6,4.33,53.64,6.51,81.02,6.51h0c50.54,0,99.96-7.43,147.49-22.13,15.84-4.9,31.47-10.61,46.86-17.12,1.86-.79,3.71-1.58,5.56-2.39,48-20.98,91.97-49.11,131.1-83.84,7.53-6.68,14.87-13.6,22.04-20.77,15.76-15.76,30.35-32.41,43.75-49.89,25.57-33.38,46.74-69.78,63.24-108.8,17.9-42.33,29.74-86.46,35.39-131.81.77-6.18,1.43-12.39,1.97-18.62.36-4.15.67-8.31.93-12.48.64-10.43.97-20.91.97-31.44,0-67.39-13.2-132.78-39.25-194.35ZM898.79,709.4c-1.69,3.2-3.41,6.39-5.17,9.55-1.76,3.16-3.56,6.3-5.4,9.41-2.75,4.67-5.59,9.29-8.51,13.85-.97,1.52-1.96,3.04-2.95,4.55-16.86,25.67-36.36,49.61-58.39,71.63-23.61,23.61-49.43,44.33-77.21,61.99-3.2,2.04-6.43,4.03-9.69,5.98-1.69,1.02-3.39,2.02-5.09,3.01-16.52,9.63-33.69,18.22-51.46,25.74-55.62,23.53-114.72,35.45-175.65,35.45-57.12,0-112.64-10.48-165.18-31.18-3.5-1.38-6.99-2.8-10.47-4.28-16.79-7.1-33.05-15.16-48.73-24.16-34.5-19.78-66.22-44.07-94.72-72.57-17.17-17.17-32.81-35.51-46.86-54.93-19.87-27.45-36.55-57.05-49.87-88.53-1.17-2.76-2.3-5.53-3.41-8.3-.16-.41-.33-.82-.5-1.24-1.05-2.65-2.07-5.31-3.07-7.97-.19-.5-.37-1-.56-1.49-.99-2.68-1.96-5.36-2.9-8.06-.13-.37-.26-.75-.39-1.12-.94-2.73-1.87-5.47-2.76-8.21-.04-.13-.09-.26-.13-.4-.9-2.79-1.77-5.58-2.61-8.38-.14-.46-.28-.93-.42-1.39-.81-2.71-1.59-5.42-2.34-8.14-.14-.5-.28-1-.41-1.51-.76-2.76-1.49-5.53-2.2-8.31-.08-.31-.15-.63-.23-.94-.69-2.75-1.36-5.51-2-8.28-.06-.25-.12-.49-.17-.74-.64-2.81-1.25-5.63-1.84-8.46-.1-.5-.21-1-.31-1.5-.57-2.76-1.11-5.53-1.62-8.3-.09-.5-.18-.99-.27-1.49-.52-2.85-1.02-5.7-1.48-8.56-.04-.23-.07-.47-.11-.7-.45-2.81-.87-5.62-1.27-8.43-.05-.34-.1-.68-.15-1.02-.39-2.84-.75-5.68-1.09-8.53-.06-.53-.13-1.06-.19-1.59-.32-2.81-.62-5.63-.9-8.45-.05-.48-.09-.96-.13-1.44-.27-2.93-.53-5.87-.74-8.81,0-.12-.02-.25-.03-.37-.21-2.9-.39-5.8-.55-8.71-.01-.27-.03-.55-.04-.82h247.06l20.56,314.48c.82,12.62,11.3,22.43,23.95,22.43h318.18c12.65,0,23.12-9.81,23.95-22.43l34.09-521.47h18.17c13.25,0,24-10.75,24-24v-73.48c0-13.25-10.75-24-24-24h-25.83v-32.45c0-13.25-10.75-24-24-24h-370.92c-13.25,0-24,10.75-24,24v32.45h-25.83c-13.25,0-24,10.75-24,24v73.48c0,13.25,10.75,24,24,24h18.16l10.39,158.99H48.63c2.73-52.46,14.4-103.36,34.83-151.65,22.73-53.74,55.27-102,96.72-143.45,41.45-41.45,89.72-74,143.45-96.72,55.62-23.53,114.72-35.45,175.65-35.45s120.03,11.93,175.65,35.45c53.74,22.73,102,55.27,143.45,96.72,41.45,41.45,74,89.72,96.72,143.45,23.53,55.62,35.45,114.72,35.45,175.65s-11.93,120.03-35.45,175.65c-4.97,11.75-10.41,23.25-16.31,34.46ZM660.74,194.81h-322.92v-8.45h322.92v8.45ZM313.82,242.81h396.75v25.48h-422.58v-25.48h25.83ZM649.93,597.48h-301.29l-7.38-112.96h316.06l-7.38,112.96ZM646.79,645.48l-10.9,166.72h-273.22l-10.9-166.72h295.01ZM668.31,316.29l-7.86,120.23h-322.33l-7.86-120.23h338.05Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeeIcon);
export default __webpack_public_path__ + "static/media/coffee_icon.b34679a7121dc2defa8c5175a9d328c8.svg";
export { ForwardRef as ReactComponent };